module.exports = __webpack_public_path__ + "img/youleyuan.df18c5e3.gif";